if (!window['CF_PAGE_BUILDER']) {
	$(document).ready(initSlider3);
}

function initSlider3() {
	var $containers = $('.js-swiper-container');

	$containers.each(function (index, container) {
		var $container = $(container);
		var $pagination = $('.js-swiper-pagination', $container);
		var itemsCount = $container.data('items-count');
		var slidesCount = $('.com-sec-slider-3__slide', $container).length;

		var sliderSwiper = new Swiper($container, {
			slidesPerView: itemsCount ? itemsCount : 5,
			slidesPerGroup: itemsCount ? itemsCount : 5,
			loop: false,
			centerInsufficientSlides: true,
			speed: 700,
			pagination: {
				el: $pagination,
				clickable: true,
				renderBullet: function (index, className) {
					return slidesCount > 5 ?
						'<span class="com-sec-slider-3__pagination-item ' + className + '">' + '<span class="com-sec-slider-3__pagination-element"></span>' + '</span>' : '';
				},
			},
			breakpoints: {
				479: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					pagination: {
						el: $pagination,
						clickable: true,
						renderBullet: function (index, className) {
							return slidesCount > 3 ?
								'<span class="com-sec-slider-3__pagination-item ' + className + '">' + '<span class="com-sec-slider-3__pagination-element"></span>' + '</span>' : '';
						},
					},
				}
			}
		});

		var $section = $('.com-sec-slider-3');
		var visibility = VisSense($section[0], {fullyvisible: 0.6});

		visibility.monitor({
			fullyvisible: function () {
				if (scroll) {
					sliderSwiper.autoplay.start();
					scroll = false;
				}
			},
		}).start();
	});
}
